import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { ReactComponent as OuraIcon } from "assets/oura.svg";

import { StyledGrid, Switch } from "components/simple";
import { color, fontSize, spacingDefaults } from "style/constants";

interface OuraPreferenceProps {
  checked: boolean;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

const OuraPreference: React.FC<OuraPreferenceProps> = ({
  checked,
  handleChange
}: OuraPreferenceProps) => {
  const [checkedStatus, setCheckedStatus] = useState<boolean>(false);

  useEffect(() => {
    setCheckedStatus(checked);
  }, [checked]);

  return (
    <StyledGrid
      alignItems="center"
      container
      height="60px"
      padding={`0 ${spacingDefaults.large}`}
    >
      <StyledGrid alignItems="center" container item xs>
        <OuraIcon />

        <Box
          color={color.DARKERGRAY}
          component="p"
          fontSize={fontSize.small}
          lineHeight="150%"
          margin={`0 0 0 ${spacingDefaults.xsmall}`}
        >
          Oura Ring
        </Box>
      </StyledGrid>

      <Switch checked={checkedStatus} onChange={handleChange} />
    </StyledGrid>
  );
};

export default OuraPreference;
